import { Text } from '@mantine/core';
import { IconVariable, IconX, IconBulb, IconSearch, IconCheck } from '@tabler/icons-react';
import type { AIMessage } from '~/common/vm/protocol';
import { CollapsibleCard } from '../CollapsibleCard';

export function AIExtractionStartCard({ message }: { message: Extract<AIMessage, { type: 'ai-extraction-start' }> }) {
  return (
    <CollapsibleCard
      icon={IconSearch}
      title="Extracting Variable"
      defaultExpanded={true}
      classNames={{
        icon: 'text-gray-600 dark:text-gray-400',
      }}
    >
      <div className="space-y-3">
        {/* Variable name with icon */}
        <div className="mx-1 flex items-center space-x-2 rounded bg-gray-100 px-3 dark:bg-gray-700">
          <IconVariable
            size={14}
            className="text-gray-600 dark:text-gray-400"
          />
          <Text
            size="sm"
            className="font-medium text-gray-800 dark:text-gray-200"
          >
            {message.variableName}
          </Text>
        </div>

        {/* Extraction prompt with icon */}
        <div className="mx-1 rounded border border-gray-200 bg-gray-50 p-3 dark:border-gray-600 dark:bg-gray-700">
          <div className="mb-2 flex items-center space-x-2">
            <IconBulb
              size={14}
              className="text-gray-600 dark:text-gray-400"
            />
            <Text
              size="xs"
              className="font-medium"
            >
              Extraction Prompt:
            </Text>
          </div>
          <Text
            size="sm"
            className="italic leading-relaxed"
          >
            {message.extractionPrompt}
          </Text>
        </div>
      </div>
    </CollapsibleCard>
  );
}

export function AIExtractionResultCard({ message }: { message: Extract<AIMessage, { type: 'ai-extraction-result' }> }) {
  const config =
    message.success ?
      {
        iconColor: 'text-gray-500 dark:text-gray-400',
        icon: IconCheck,
        title: 'Extraction Successful',
      }
    : {
        iconColor: 'text-gray-500 dark:text-gray-400',
        icon: IconX,
        title: 'Extraction Failed',
      };

  return (
    <CollapsibleCard
      icon={config.icon}
      title={config.title}
      defaultExpanded={true}
      classNames={{
        icon: config.iconColor,
      }}
    >
      <div className="space-y-3">
        {/* Variable name with icon */}
        <div className="mx-1 flex items-center space-x-2 rounded bg-gray-100 px-3 dark:bg-gray-700">
          <IconVariable
            size={14}
            className="text-gray-600 dark:text-gray-400"
          />
          <Text
            size="sm"
            className="font-medium text-gray-800 dark:text-gray-200"
          >
            {message.variableName}
          </Text>
        </div>

        {/* Extracted value (only show if successful) */}
        {!!message.success && (
          <div className="mx-1 rounded border border-gray-200 bg-gray-50 p-3 dark:border-gray-600 dark:bg-gray-700">
            <Text
              size="sm"
              className="leading-relaxed"
            >
              &quot;{message.extractedValue}&quot;
            </Text>
          </div>
        )}
      </div>
    </CollapsibleCard>
  );
}
